const requiredText = (inputTextValue, name) =>
  inputTextValue && inputTextValue.trim() !== '' ? '' : `Enter valid ${name || 'value'}`;

const emailFormat = (email) =>
  email &&
  email.trim() !== '' &&
  /* eslint-disable-next-line no-useless-escape */
  (/^([a-zA-Z0-9_.-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.trim())
    ? ''
    : 'Enter valid email');

const validators = {
  requiredText,
  emailFormat,
};

export default validators;
